export enum SearchPriorityEnum {
    Must = 0,
    Should = 1,
    Disabled = 2,
    Excluded = 3
}